<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div class="is-flex is-align-items-center">
      <div class="control is-flex-grow-1 mr-5">
        <input
          class="input"
          type="number"
          placeholder="between 5,000 to 100,000 ils"
          :min="MIN"
          :max="MAX"
          :value="draft"
          @input="updateValue"
          :class="{ field_error: isError }"
          @focusout="handleChange"
        />
      </div>
      <div class="mx-3">
        <button class="button is-info" @click="calculate">חשב</button>
      </div>
      <label class="checkbox p-0">
        <Checkbox :checked="isInvoice" @input="(e) => { isInvoice = e; handleChange() }">חשבונית?</Checkbox>
      </label>
      <label class="checkbox p-0 pl-4">
        <Checkbox :checked="isNeto" @input="(e) => { isNeto = e; handleChange() }">נטו</Checkbox>
      </label>
    </div>
    <p v-if="isError" class="is-size-7 has-text-danger">Please enter a value between 5,000 and 100,000 ILS.</p>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox'

// Applicant min / max salary expectation (one component, `field` picks the
// column). The parent's v-model only ever receives a VALID value (or '' for
// cleared); an out-of-range draft stays local and is never saved.
const FIELDS = {
  min: { column: 'min_salary_expectations', label: 'Min Salary Expectations' },
  max: { column: 'max_salary_expectations', label: 'Max Salary Expectations' }
}

export default {
  name: 'ApplicantSalaryExpectations',
  components: { Checkbox },
  props: {
    field: {
      type: String,
      default: 'min',
      validator: v => Object.keys(FIELDS).includes(v)
    },
    value: {
      type: [String, Number],
      validator: prop => typeof prop === 'number' || typeof prop === 'string' || prop === null
    },
    applicantId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      MIN: 5000,
      MAX: 100000,
      draft: this.value == null ? '' : this.value,
      savedValue: this.value == null ? '' : String(this.value),
      isInvoice: false,
      isNeto: false,
      isError: false
    }
  },
  computed: {
    label () {
      return FIELDS[this.field].label
    },
    calculatedValue () {
      if (this.draft === '' || this.draft === null) return ''
      const invoice = this.isInvoice ? 0.7 : 1
      const neto = this.isNeto ? 1.54 : 1
      return Number(this.draft) * invoice * neto
    }
  },
  watch: {
    value (newVal) {
      const v = newVal == null ? '' : newVal
      if (String(v) !== String(this.draft)) {
        this.draft = v
        this.savedValue = String(v)
        this.setError(false)
      }
    }
  },
  methods: {
    isValid (value) {
      if (value === '' || value === null) return true
      const n = Number(value)
      return !isNaN(n) && n >= this.MIN && n <= this.MAX
    },
    setError (state) {
      if (this.isError !== state) {
        this.isError = state
        this.$emit('error', state)
      }
    },
    updateValue (event) {
      this.draft = event.target.value
      const ok = this.isValid(this.draft)
      this.setError(!ok)
      if (ok) this.$emit('input', this.draft)
    },
    calculate () {
      if (this.isError || this.calculatedValue === '') return
      this.draft = this.calculatedValue
      this.$emit('input', this.calculatedValue)
      this.isInvoice = false
      this.isNeto = false
    },
    async handleChange () {
      if (this.isError) {
        this.$utils.emit('show_toast', { text: 'Failed to update applicant' })
        return
      }
      const toSave = this.calculatedValue
      if (String(toSave) === this.savedValue) return
      try {
        await this.$network_utils.updateApplicant({
          applicant_id: this.applicantId,
          [FIELDS[this.field].column]: toSave === '' ? null : toSave
        })
        this.savedValue = String(toSave)
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'Failed to update applicant' })
      }
    }
  }
}
</script>
